import { createSlice } from "@reduxjs/toolkit";

interface CourseItem {
    Id: number;
    Name: string;
    Type: string;
}

interface CoursePreferencesState {
    boardDetails: CourseItem[];
    classDetails: CourseItem[];
    educationInterestDetails: CourseItem[];
    subjectDetails: CourseItem[];
}

const initialState: CoursePreferencesState = {
    boardDetails: [],
    classDetails: [],
    educationInterestDetails: [],
    subjectDetails: []
};

const coursePreferencesSlice = createSlice({
    name: "coursePreferences",
    initialState,
    reducers: {
        setCoursePreferences: (state, action) => {
            const { boardDetails, classDetails, educationInterestDetails, subjectDetails } = action.payload;
            state.boardDetails = boardDetails || [];
            state.classDetails = classDetails || [];
            state.educationInterestDetails = educationInterestDetails || [];
            state.subjectDetails = subjectDetails || [];
        },
        clearCoursePreferences: (state) => {
            return initialState;
        }
    }
});

export default coursePreferencesSlice.reducer;
export const { setCoursePreferences, clearCoursePreferences } = coursePreferencesSlice.actions;